<div class="page-wrapper">
  <qai-inner-wrap>
    <div class="container" *ngIf="isTranslationLoaded">
      <div class="content-header">
        <div class="content-header-left">
          <h2 class="content-title">
            {{ headerText }}
          </h2>
          <qai-label
            *ngIf="subtitleText"
            [kind]="'secondary'"
            [size]="'small'"
            [weight]="'regular'"
          >
            {{ subtitleText }}
          </qai-label>
        </div>

        <div *ngIf="displayLowSkillsFilter" class="content-header-right">
          <qai-label [kind]="'secondary'" [size]="'small'" [weight]="'regular'">
            <div class="content-header-inner">
              {{ "leaderboard.HIDE_SESSIONS_WITH_LOW_SCORE" | transloco }}
              <button #floatingRef type="button" class="icon-button">
                <qai-icon [kind]="'help-circle'" size="16px" />
              </button>
            </div>

            <qai-tooltip
              [qaiFloating]="floatingRef"
              [placement]="'below-center'"
              [events]="['hover']"
              [style.maxWidth]="'270px'"
            >
              {{ "leaderboard.SESSIONS_WITH_LOW_SCORE_TOOLTIP" | transloco }}
            </qai-tooltip>
          </qai-label>

          <input
            qai-toggle-switch
            type="checkbox"
            [size]="'medium'"
            [name]="'ts-default'"
            [checked]="excludeLowSkills"
            (change)="onSkillsFilteringChange($event)"
          />
        </div>
      </div>

      <div class="table-wrapper">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-container">
          <qai-loading [size]="'medium'"></qai-loading>
        </div>

        <!-- Data Loaded State -->
        <qai-table
          *ngIf="!isLoading"
          [headers]="headers"
          [data]="tableData"
          [striped]="false"
          [initialSortColumn]="initialSortColumn"
          [initialSortDirection]="initialSortDirection"
          (sortChanged)="onSortChanged($event)"
          [sortingPriority]="sortingPriority"
        >
        </qai-table>

        <!-- No Selection State -->
        <div
          *ngIf="!isLoading && (!selectedAssignment || !selectedSimulation)"
          class="empty-container"
        >
          <p>
            {{ "leaderboard.SELECT_ASSIGNMENT_AND_SIMULATION" | transloco }}
          </p>
        </div>

        <!-- No Data State -->
        <div
          *ngIf="
            !isLoading &&
            tableData.length === 0 &&
            selectedAssignment &&
            selectedSimulation
          "
          class="empty-container"
        >
          <p>
            {{ "leaderboard.NO_DATA" | transloco }}
          </p>
        </div>
      </div>
    </div>
  </qai-inner-wrap>
</div>
